import { gql } from '@apollo/client';

export const GET_CATEGORIES = gql`
  query {
    categories {
      id
      name
      description
      code
      enabledToolCount
    }
  }
`;
